import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import { parseHtmlImages, addAside, addAsideHtml } from '../components/utitlies/utility';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { Link, navigate } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import UseScript from '../hooks/use-script';
import { css } from '@emotion/react';
import '../components/veterinary/veterinary.css'; //two logos and a h1 use this css.
import '../components/ipap/ipap.css';
import '../components/css/aside.css';
import { decode } from 'html-entities'; // Import html-entities library

// regex to find custom pages
const ipap_regex = /ipap/gi;
const saam_regex = /saam/gi;
const life_regex = /life/gi;
const medcoe_learn_regex =
  /medcoe-learn-(bitesize-learning|films-and-podcasts|insights|publications|resources|home)/gi;

function Public({ data }) {
  const publicContent = data.medcoePublicContentJson;
  const docNames = data.allMedcoeDocNameJson.edges;

  // Replace problematic characters in PageContent
  let cleanedPageContent = publicContent.PageContent.replace(/&apos;/g, "'") // Replace HTML entity for apostrophe
    .replace(/`/g, "'"); // Replace backticks with apostrophe

  // console.log('publicContent.PortletName', publicContent.PortletName);
  // redirect from /soldier-outlook-archive to /soldier-outlook
  if (typeof window !== 'undefined') {
    if (window.location.pathname === '/soldier-outlook-archive') {
      navigate('/soldier-outlook');
    }
    if (typeof document !== `undefined`) {
      if (
        publicContent.PortletName === 'Learn Tech' ||
        publicContent.PortletName === 'DOTD'
      ) {
        UseScript('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js');
        UseScript(
          'https://ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js'
        );
        UseScript('https://cdn.datatables.net/1.10.19/js/jquery.dataTables.min.js');
        UseScript('https://cdn.datatables.net/1.10.19/js/dataTables.jqueryui.min.js');
        UseScript(
          'https://cdn.datatables.net/responsive/2.2.3/js/dataTables.responsive.min.js'
        );
        UseScript(
          'https://cdn.datatables.net/responsive/2.2.3/js/responsive.jqueryui.min.js'
        );
      }
    }
  }

  // console.log('**** - CONTENT:', publicContent.PageContent);
  // console.log('doc names', docNames);
  // console.log('page title', publicContent.PortletName);

  let newHtml = '';
  let arrHTags = [];

  newHtml = parseHtmlImages(
    cleanedPageContent, // Use cleaned content
    docNames,
    publicContent.PortletName,
    data.allMedcoePublicContentJson.edges
  );

  // add the aside to the side of the content.
  arrHTags = addAside(newHtml, publicContent.PortletName.toLowerCase().trim());

  // Add the id to each header tag
  newHtml = addAsideHtml(newHtml, publicContent.PortletName.toLowerCase().trim());
  // aside for default pages
  let newSideNav = '';
  if (arrHTags.length > 0 && !publicContent.PortletName.match(medcoe_learn_regex)) {
    newSideNav = arrHTags.map((tag) => {
      const decodedTag = decode(tag); // Decode HTML entities
      const newTag = decodedTag.replace(/(<([^>]+)>)/gi, '');
      if (decodedTag === '') {
        return null;
      }
      return (
        <li>
          <AnchorLink
            href={`#${decodedTag
              .replace(/ /g, '-')
              .replace(/\&nbsp;/g, '')
              .toLowerCase()}`}
          >
            {newTag.replace(/\w+/g, function (w) {
              return w[0].toUpperCase() + w.slice(1);
            })}
          </AnchorLink>
        </li>
      );
    });
  }

  return (
    <Layout>
      <div className='grid-container'>
        {/* Custom Banner and Navs*/}
        {/* 1. IPAP Nav and Banner */}
        {publicContent.PortletName.match(ipap_regex) && (
          <React.Fragment>
            <Link to='/ipap'>
              <StaticImage
                src='../images/IPAPheader.jpg'
                css={css`
                  margin: 0 auto;
                  display: flex;
                `}
                alt='IPAP header'
                formats={["auto", "jpg"]}
              />
            </Link>
            <header className='link-header' role='banner'>
              <div className='link-container'>
                <nav role='navigation' className='nav'>
                  <ul className='link-list'>
                    <li>
                      <Link className='nav-link' to='/ipap'>
                        <span>Home</span>
                      </Link>
                    </li>
                    <li>
                      <Link className='nav-link' to='/ipap-prospective-student-students'>
                        <span>Prospective Students</span>
                      </Link>
                    </li>
                    <li>
                      <Link className='nav-link' to='/ipap-standards'>
                        <span>Standards</span>
                      </Link>
                    </li>

                    <li>
                      <Link className='nav-link' to='/ipap-program-goals'>
                        <span>Program Goals</span>
                      </Link>
                    </li>
                    <li>
                      <Link className='nav-link' to='/ipap-program-competencies'>
                        <span>Program Competencies</span>
                      </Link>
                    </li>
                    <li>
                      <Link className='nav-link' to='/ipap-history'>
                        <span>History</span>
                      </Link>
                    </li>
                    <li>
                      <Link className='nav-link' to='/ipap-faq'>
                        <span>Faq</span>
                      </Link>
                    </li>
                    <li>
                      <Link className='nav-link' to='/ipap-links'>
                        <span>Links</span>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </header>
          </React.Fragment>
        )}
        {/* 2. SAAM Nav and Banner */}
        {publicContent.PortletName.match(saam_regex) && (
          <React.Fragment>
            <Link to='/saam'>
              <div
                className='bg-header'
                css={css`
                  background-image: url('https://medcoe.army.mil/pfw-images/dbimages/saam-header.png');
                  background-repeat: no-repeat;
                  min-height: 150px;
                  background-size: contain;
                  position: relative;
                  @media screen and (max-width: 951px) {
                    min-height: 60px;
                  }
                `}
              >
                <StaticImage
                  src='../images/saam-logo2.png'
                  formats={['png']}
                  css={css`
                    width: 100px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    @media screen and (max-width: 951px) {
                      display: none;
                    }
                  `}
                  alt='saam logo'
                />
                <h1
                  css={css`
                    position: absolute;
                    display: inline;
                    left: 120px;
                    bottom: 0;
                    color: whitesmoke;
                    text-shadow: 2px 2px #000;
                    @media screen and (max-width: 951px) {
                      font-size: 15px;
                      position: initial;
                      display: initial;
                      text-decoration: none !important;
                    }
                  `}
                >
                  Department of Aviation Medicine
                </h1>
              </div>
            </Link>

            <nav
              css={css`
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: stretch;
                min-height: 28px;
                background-color: #f1f1f1;
                font-size: 14px;
                padding: 10px;
                margin-bottom: 24px;
                border-radius: 6px;
                a {
                  color: #333;
                  text-decoration: none;
                }
                a:hover {
                  text-decoration: underline;
                }
                @media screen and (max-width: 951px) {
                  flex-direction: column;
                  a {
                    padding: 5px 10px;
                    border: 1px solid darkgray;
                  }
                }
              `}
            >
              <Link to='/saam-afsc'>Flight Surgeon</Link>
              <Link to='/saam-aptc'>Aeromedical Psychology</Link>
              <Link to='/saam-chamber'>Hypobaric Chamber</Link>
              <Link to='/saam-aacc'>AACC</Link>
              <Link to='/saam-jecc'>JECC</Link>
              <Link to='/saam-medc'>MEDEVAC Doctrine</Link>
              <Link to='/saam-pcc'>Pre-Command Course</Link>
              <Link to='/saam-rams'>GME/RAM</Link>
              <Link to='/saam-registrar'>Registrar</Link>
              <Link to='/saam-contact'>Contact</Link>
            </nav>
          </React.Fragment>
        )}
        {/* 3. Medcoe Learn Nav and Banner */}
        {/*{publicContent.PortletName.match(medcoe_learn_regex) && (
          <React.Fragment>
            <div
              css={css`
                position: relative;
                text-align: center;
              `}
            >
              <Link to='/medcoe-learn-home'>
                <StaticImage
                  src='https://medcoeckapwstorprd01.blob.core.usgovcloudapi.net/pfw-images/dbimages/medevacchopper.jpg'
                  css={css`
                    width: 100%;
                    height: auto;
                  `}
                  alt='Medcoe Learn header'
                />
              </Link>
              <div
                css={css`
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  background-color: maroon;
                  opacity: 0.75;
                  padding: 10px 0;
                `}
              >
                <nav
                  css={css`
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                  `}
                >
                  <Link
                    className='nav-link'
                    to='/medcoe-learn-home'
                    css={css`
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                    `}
                  >
                    Home
                  </Link>
                  <Link
                    className='nav-link'
                    to='/medcoe-learn-bitesize-learning'
                    css={css`
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                    `}
                  >
                    Bitesize Learning
                  </Link>
                  <Link
                    className='nav-link'
                    to='/medcoe-learn-films-and-podcasts'
                    css={css`
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                    `}
                  >
                    Films and Podcasts
                  </Link>
                  <Link
                    className='nav-link'
                    to='/medcoe-learn-insights'
                    css={css`
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                    `}
                  >
                    Insights
                  </Link>
                  <Link
                    className='nav-link'
                    to='/medcoe-learn-publications'
                    css={css`
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                    `}
                  >
                    Publications
                  </Link>
                  <Link
                    className='nav-link'
                    to='/medcoe-learn-resources'
                    css={css`
                      color: white;
                      text-decoration: none;
                      font-weight: bold;
                    `}
                  >
                    Resources
                  </Link>
                </nav>
              </div>
            </div>
          </React.Fragment>
        )}*/}
        {/* 4. Life Connection Nav and Banner */}
        {publicContent.PortletName.match(life_regex) && (
          <React.Fragment>
            <div
              className='banner padding-2'
              css={css`
                background-color: #f1f1f1;
                display: flex;
                text-decoration: none !important;
                @media screen and (max-width: 951px) {
                  min-height: 60px;
                }
              `}
            >
              <StaticImage
                src='../images/life-connection-logo.jpg'
                css={css`
                  width: 160px;
                  @media screen and (max-width: 951px) {
                    width: 60px;
                  }
                `}
                alt='life connection logo'
                formats={["auto", "jpg"]}
              />
              <div className='banner-text margin-left-2'>
                <h1
                  className='font-sans-xl text-normal'
                  css={css`
                    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto,
                      Arial, sans-serif !important;

                    @media screen and (max-width: 951px) {
                      font-size: 15px;
                    }
                  `}
                >
                  Life Connection
                </h1>
                <h3
                  className='margin-top-neg-3 text-normal text-gray-50'
                  css={css`
                    font-family: Source Sans Pro Web, Helvetica Neue, Helvetica, Roboto,
                      Arial, sans-serif !important;
                    @media screen and (max-width: 951px) {
                      display: none;
                    }
                  `}
                >
                  Fostering a culture of readiness, resiliency, and trust through building
                  connections and focusing on personal and relational health aimed at
                  suicide prevention and self-care
                </h3>
              </div>
            </div>

            <nav
              css={css`
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: stretch;
                min-height: 28px;
                background-color: #ccc;
                font-size: 14px;
                padding: 10px;
                margin-bottom: 24px;
                border-radius: 6px;
                align-items: center;
                a {
                  color: #333;
                  text-decoration: none;
                  padding-left: 30px;
                }
                a:hover {
                  text-decoration: underline;
                }
                @media screen and (max-width: 951px) {
                  flex-direction: column;
                  a {
                    padding: 5px 10px;
                    border: 1px solid darkgray;
                  }
                }
              `}
            >
              <Link to='/life-connection'>Home</Link>
              <Link to='/life-connection-behavioral-health'>Behavioral Health</Link>
              <Link to='/life-connection-chaplain'>Chaplain</Link>
              <Link to='/life-connection-resources'>Resources</Link>

              {/* Crisis Line  link */}
              <a
                href='https://www.veteranscrisisline.net/get-help/military-crisis-line'
                css={css`
                  margin-left: auto;
                  padding: 7px 10px !important;
                  @media screen and (max-width: 951px) {
                    margin-left: initial;
                  }
                `}
              >
                <StaticImage
                  src='../images/mclhozpms.png'
                  alt='vetrans crisis line'
                  width={80}
                  className='margin-0'
                />
              </a>
            </nav>
          </React.Fragment>
        )}

        <div className='grid-row grid-gap'>
          {/* new Aside for generic pages */}
          {arrHTags.length > 0 && !publicContent.PortletName.match(medcoe_learn_regex) ? (
            <div className='desktop:grid-col-3'>
              <aside>
                <nav>
                  <ul className='usa-sidenav'>{newSideNav}</ul>
                </nav>
              </aside>
            </div>
          ) : null}

          <div
            className={
              'usa-layout-docs__main usa-prose ' +
              (arrHTags.length > 0 && !publicContent.PortletName.match(medcoe_learn_regex)
                ? 'desktop:grid-col-9'
                : 'desktop:grid-col-12')
            }
          >
            {/* 4. Everyone Else */}
            <div dangerouslySetInnerHTML={{ __html: newHtml }} />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query OneViewTypeMessage($id: Int) {
    medcoePublicContentJson(PortletID: { eq: $id }) {
      PortletID
      PageContent
      PortletName
    }
    allFile {
      edges {
        node {
          base
          publicURL
        }
      }
    }
    allMedcoeDocNameJson {
      edges {
        node {
          document_name
          id
          docGuid
        }
      }
    }
    allMedcoePublicContentJson {
      edges {
        node {
          PortletName
          PortletGuid
        }
      }
    }
  }
`;

export default Public;
